import useDimensions from '@/shared/hooks/useDimensions';
import { WELCOME_SECTION_BREAKPOINT } from '@/shared/styles/constants';

export interface WelcomeSectionLayout {
  width: number;
  isWide: boolean;
}

export function useWelcomeSectionLayout(): WelcomeSectionLayout {
  const { width } = useDimensions();
  return {
    width,
    isWide: width >= WELCOME_SECTION_BREAKPOINT,
  };
}
